<div class="body ui container" fxLayout="column">
  <div
    fxLayout="row"
    fxLayoutAlign="flex-start center"
    class="top"
    fxLayoutGap="15px"
  >
    <div *ngIf="!(showLotList || showDetail)">
      <span>Home</span>
      <h2 class="ui primary header">Tenders</h2>
    </div>
    <ng-container *ngIf="showLotList || showDetail">
      <img
        (click)="showLotList = showDetail = false"
        style="cursor: pointer"
        src="assets/icons/left-arrow-icon.svg"
        alt="Back"
      />
      <div>
        <span>Tenders</span>
        <h2 class="ui primary header">
          {{ showLotList ? "View Selected Lots" : "View Lot" }}
        </h2>
      </div>
    </ng-container>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>

  <esl-message-toast
    [(message)]="success"
    [messageType]="success"
  ></esl-message-toast>
  <esl-message-toast [(message)]="error"></esl-message-toast>

  <div
    class="main-flex ui vertical segment"
    [ngClass]="{ loading: pendingArr?.length }"
  >
    <div>
      <div class="lot-store">
        <div class="info" *ngIf="listItems?.length">
          Your List has a Lot now! To add more, choose a lot from the right side
          and click the "Add to List" button"
        </div>
        <div class="info" *ngIf="!listItems?.length">
          Your List currently doesn't have any Lots. To add one, please choose a
          Lot from the right side and click the “Add to List” button.
        </div>
        <div class="info-group">
          <div class="number">{{ listItems?.length }}</div>
          <div class="lot-info">Lots added to your List</div>
        </div>
        <div style="text-align: center">
          <button
            class="ui button"
            (click)="viewLotList()"
            *ngIf="!(showLotList || showDetail)"
          >
            View List
          </button>
          <button
            class="ui button"
            (click)="showLotList = showDetail = false"
            *ngIf="showLotList || showDetail"
          >
            View Selected Lots
          </button>
        </div>
      </div>

      <div *ngIf="!showLotList && !showDetail">
        <div class="filter">FILTER</div>
        <div class="ui divider" appMargin marginY="3"></div>
        <div class="category-group">
          <div class="category">CATEGORY</div>
          <div class="checkbox" *ngFor="let category of categories">
            <input
              type="checkbox"
              id="{{ category.optionId }}"
              class="category"
              (change)="onCheckboxChange($event, category)"
            />
            <label for="{{ category.optionName }}">{{
              category.optionName
            }}</label>
          </div>
        </div>
        <div class="category-group">
          <div class="category">TENDER TYPE</div>
          <div class="checkbox" *ngFor="let tenderType of tenderTypes">
            <input
              type="checkbox"
              id="{{ tenderType.biddingStageId }}"
              class="tenderType"
              (change)="onCheckboxChange($event, tenderType)"
            />
            <label for="{{ tenderType.biddingStageName }}">{{
              tenderType.biddingStageName
            }}</label>
          </div>
        </div>
        <!-- <div class="category-group">
          <div class="category">LOCATION</div>
          <div class="checkbox">
            <input type="checkbox" /> <span>Abuja</span>
          </div>

          <div class="checkbox">
            <input type="checkbox" /> <span>Lagos</span>
          </div>

        </div> -->
      </div>
    </div>
    <div class="horizontal-line"></div>
    <ng-container *ngIf="!showLotList && !showDetail">
      <div style="width: 100%">
        <div
          class="ui segment"
          style="border-radius: 4px"
          appMargin
          marginT="0"
        >
          <app-advanced-search-filter
            [hasFilters]="false"
            [hasAdvancedSearch]="false"
            [showExportBtn]="false"
            (onSearch)="searchRecords($event)"
            (onDisplayRows)="displayRecords($event)"
            (onSort)="sortRecords($event)"
          ></app-advanced-search-filter>
        </div>

        <div class="ui vertical basic segment">
          <app-no-record-found
            *ngIf="projects && projects.length < 1"
          ></app-no-record-found>
          <app-no-record-found *ngIf="!projects"></app-no-record-found>

          <div
            class="border-segment"
            *ngFor="let project of projects"
            (click)="log(project)"
          >
            <div fxLayout="row" fxLayoutAlign="start center" class="t-body">
              <div fxFlex="grow">
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  fxLayoutGap="15px"
                  appMargin
                  marginB="1"
                >
                  <div class="company-pill" *ngIf="project?.lotAmount">
                    {{ project?.lotAmount | currency: "₦" }}
                  </div>
                  <div
                    class="company-pill"
                    *ngIf="project?.requiredProcCategory"
                  >
                    {{ project?.requiredProcCategory }}
                  </div>
                  <div
                    class="company-pill"
                    *ngIf="project?.procurementLocation"
                  >
                    {{ project?.procurementLocation }}
                  </div>
                </div>

                <div
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  fxLayoutGap="15px"
                  appMargin
                  marginB="1"
                >
                  <div style="width: 75%" class="company-description">
                    {{ project?.lotName }}
                  </div>
                </div>
                <div
                  class="t-content"
                  fxLayout="row"
                  fxLayoutAlign="start start"
                  fxLayoutGap="15px"
                >
                  <div style="width: 14%">
                    <div class="label">Lot Number</div>
                    <div class="value" style="font-weight: 600">
                      {{ project?.lotNumber || project?.lot?.lotNumber }}
                    </div>
                  </div>
                  <div style="width: 18%">
                    <div class="label">Required Annual Turnover</div>
                    <div class="value" *ngIf="project?.requiredAnnualTurnOver">
                      {{ project?.requiredAnnualTurnOver | currency: "₦" }}
                    </div>
                    <div class="value" *ngIf="!project?.requiredAnnualTurnOver">
                      ₦ 0.00
                    </div>
                  </div>
                  <div style="width: 22%">
                    <div class="label">Tender Type</div>
                    <div class="value">
                      {{
                        project?.biddingStageName ||
                          project?.biddingStage?.biddingStageName
                      }}
                    </div>
                  </div>
                  <div style="width: 23%">
                    <div class="label">Date Created</div>
                    <div class="value">
                      {{
                        project?.dateCreated || project?.bidOpeningDate
                          | date: "d MMM, y h:mm a"
                      }}
                    </div>
                  </div>

                  <div
                    style="width: 6%; padding: 0; margin: 0"
                    fxLayout="column"
                    fxLayoutAlign="end flex-end"
                  >
                    <button
                      class="ui tiny circular icon button"
                      suiPopup
                      popupText="View Details"
                      (click)="viewLotDetail(project)"
                    >
                      <i class="eye icon"></i>
                    </button>
                  </div>
                  <div
                    style="width: 16%"
                    fxLayout="column"
                    fxLayoutAlign="center flex-end"
                  >
                    <button
                      *ngIf="!itemIsInList(project)"
                      (click)="addItemToList(project)"
                      class="ui primary button"
                      style="font-size: 12px"
                    >
                      Add to list
                    </button>
                    <button
                      *ngIf="itemIsInList(project)"
                      (click)="confirmRemove(project)"
                      class="ui basic primary button"
                      style="font-size: 12px; height: 100%"
                    >
                      Remove Lot
                    </button>
                  </div>
                </div>
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  fxLayoutGap="15px"
                  appMargin
                  marginB="1"
                >
                  <div style="width: 30%">
                    <div class="label">Submission Time Left</div>
                    <div
                      class="value"
                      [class.green]="project?.time === 'active'"
                      [class.elapsed]="project?.time === 'elapsed'"
                      [class.not_started]="project?.time === 'not_started'"
                    >
                      {{ project?.liveTime }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ui vertical basic segment">
            <div class="ui two column grid">
              <div class="column middle aligned">
                <div class="ui icon small button">
                  <i class="database icon"></i>
                </div>
                <a class="ui basic label">{{ totalItems }} Record(s)</a>
              </div>
              <div
                class="column right aligned pagination menu"
                style="margin-left: auto"
              >
                <sui-pagination
                  class="small"
                  [collectionSize]="totalItems"
                  [pageSize]="rows"
                  [maxSize]="maxSize"
                  [hasEllipses]="false"
                  [page]="currentPage"
                  (pageChange)="nextPage($event)"
                >
                </sui-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Added Lot list -->
    <ng-container *ngIf="showLotList && !showDetail">
      <div style="width: 100%" class="ui vertical basic segment">
        <app-no-record-found *ngIf="!listItems?.length"></app-no-record-found>
        <div demo class="ui info message">
          <span>
            <img src="assets/icons/icon9.svg" alt="" />
            A submission slip is required to be attached to your bid documents
            submission. Click on the Print Slip button of a specific Lot and
            follow the system instructions to generate a submission slip for
            that Lot. You are required to login before printing a submission
            slip. If you don’t have an account, following the instructions of
            the Print Slip page to create one. Submissions Slips cannot be
            printed if Tenders Fee is unpaid.</span
          >
        </div>
        <div class="border-segment" *ngFor="let item of listItems">
          <div fxLayout="row" fxLayoutAlign="start center" class="t-body">
            <div fxFlex="grow">
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                appMargin
                marginB="1"
              >
                <div class="company-pill" *ngIf="item?.lotAmount">
                  {{ item?.lotAmount | currency: "₦" }}
                </div>
                <div class="company-pill" *ngIf="item?.requiredProcCategory">
                  {{ item?.requiredProcCategory }}
                </div>
                <div class="company-pill" *ngIf="item?.procurementLocation">
                  {{ item?.procurementLocation || "NA" }}
                </div>
              </div>

              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                appMargin
                marginB="1"
              >
                <div style="width: 75%" class="company-description">
                  {{ item?.lotName }}
                </div>
              </div>
              <div
                class="t-content"
                fxLayout="row"
                fxLayoutAlign="start start"
                fxLayoutGap="15px"
              >
                <div style="width: 14%">
                  <div class="label">Lot Number</div>
                  <div class="value" style="font-weight: 600">
                    {{ item?.lotNumber || item?.lot?.lotNumber }}
                  </div>
                </div>
                <div style="width: 18%">
                  <div class="label">Required Annual Turnover</div>
                  <div class="value" *ngIf="project?.requiredAnnualTurnOver">
                    {{ project?.requiredAnnualTurnOver | currency: "₦" }}
                  </div>
                  <div class="value" *ngIf="!project?.requiredAnnualTurnOver">
                    ₦ 0.00
                  </div>
                </div>
                <div style="width: 22%">
                  <div class="label">Tender Type</div>
                  <div class="value">
                    {{
                      item?.biddingStageName ||
                        item?.biddingStage?.biddingStageName
                    }}
                  </div>
                </div>
                <div style="width: 23%">
                  <div class="label">Date Created</div>
                  <div class="value">
                    {{ item?.bidOpeningDate | date: "d MMM, y h:mm a" }}
                  </div>
                </div>

                <div
                  style="width: 6%; padding: 0; margin: 0"
                  fxLayout="column"
                  fxLayoutAlign="end flex-end"
                >
                  <button
                    class="ui tiny circular icon button"
                    suiPopup
                    popupText="Remove Lot"
                    (click)="deleteLot(item)"
                  >
                    <img src="assets/icons/View (1).svg" alt="" />
                  </button>
                </div>

                <div
                  style="width: 6%; padding: 0; margin: 0"
                  fxLayout="column"
                  fxLayoutAlign="end flex-end"
                >
                  <button
                    class="ui tiny circular icon button"
                    suiPopup
                    popupText="View Lot"
                    (click)="viewLotDetail(item)"
                  >
                    <i class="eye icon"></i>
                  </button>
                </div>

                <div
                  style="width: 16%"
                  fxLayout="column"
                  fxLayoutAlign="end flex-end"
                >
                  <div>
                    <button
                      class="ui basic primary button"
                      style="font-size: 12px"
                      (click)="printSlip(item)"
                    >
                      <img src="assets/icons/printer.svg" alt="" /> Print slip
                    </button>
                  </div>
                </div>
              </div>
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="15px"
                appMargin
                marginB="1"
              >
                <div style="width: 15%">
                  <div class="label">Tender Amount/Status</div>
                  <div
                    class="value pill"
                    [style.background]="
                      selectColor(!item?.requiresPayment ? 'free' : 'unpaid')
                    "
                  >
                    {{ !item?.requiresPayment ? "FREE" : "UNPAID" }}
                  </div>
                </div>
                <div style="width: 30%">
                  <div class="label">Submission Time Left</div>
                  <div
                    class="value"
                    [class.green]="item?.time === 'active'"
                    [class.elapsed]="item?.time === 'elapsed'"
                    [class.not_started]="item?.time === 'not_started'"
                  >
                    {{ item?.liveTime }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- View Lot Details-->
    <ng-container *ngIf="showDetail">
      <div style="width: 100%">
        <div class="title-container">
          <div class="header-20">LOT DETAILS</div>
          <div class="flex-display" style="gap: 10px">
            <button
              (click)="printSlip(lotViewDetails)"
              class="ui normal button"
              style="
                font-size: 12px;
                font-weight: 400;
                padding: 7px 15px;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <img src="assets/icons/printer.svg" alt="" />
              <span style="margin-left: 8px">Print Submission Slip</span>
            </button>

            <button
              *ngIf="!itemIsInList(lotViewDetails)"
              class="ui primary button"
              style="font-size: 12px; font-weight: 400"
              (click)="addItemToList(lotViewDetails)"
            >
              Add to List
            </button>
          </div>
        </div>
        <div>
          <div class="contract-header2"></div>
          <div>
            <p class="ui description">Project Description</p>
            <p class="title">
              {{ lotViewDetails?.lotName }}
            </p>
          </div>
          <div class="ui divider"></div>
          <div>
            <p class="ui description">Lot Number</p>
            <p class="title">
              {{ lotViewDetails?.lotNumber || lotViewDetails?.lot?.lotNumber }}
            </p>
          </div>
          <div class="ui divider"></div>
          <div>
            <p class="ui description">Submission time left</p>
            <p
              class="title"
              [class.green]="lotViewDetails?.time === 'active'"
              [class.elapsed]="lotViewDetails?.time === 'elapsed'"
              [class.not_started]="lotViewDetails?.time === 'not_started'"
            >
              {{ lotViewDetails?.liveTime }}
            </p>
          </div>
          <div class="ui divider"></div>
          <div>
            <p class="ui description">Bid opening Date/Time</p>
            <p class="title">
              {{
                lotViewDetails?.publishStartDate || lotViewDetails?.startDate
                  | date: "MMM d, y h:mm a"
              }}
            </p>
          </div>
          <div class="ui divider"></div>
          <div>
            <p class="ui description">Category</p>
            <p class="title">
              {{ lotViewDetails?.requiredProcCategory || "---" }}
            </p>
          </div>
          <div class="ui divider"></div>
          <div>
            <p class="ui description">Project Location</p>
            <p class="title">
              {{ lotViewDetails?.procurementLocation || "---" }}
            </p>
          </div>
          <div class="ui divider"></div>
          <div>
            <p class="ui description">Tender Fee</p>
            <p class="title">
              {{ lotViewDetails?.lotAmount || "---" }}
            </p>
          </div>
          <div class="ui divider"></div>
          <div>
            <p class="ui description">Tender Type</p>
            <p class="title">
              {{
                lotViewDetails?.biddingStageName ||
                  lotViewDetails?.biddingStage?.biddingStageName
              }}
            </p>
          </div>
          <div class="ui divider"></div>
          <div>
            <p class="ui description">Required Annual Turnover</p>
            <p
              class="title"
              *ngIf="lotViewDetails?.lot?.requiredAnnualTurnOver"
            >
              {{ lotViewDetails?.lot?.requiredAnnualTurnOver | currency: "₦" }}
            </p>
            <p
              class="title"
              *ngIf="!lotViewDetails?.lot?.requiredAnnualTurnOver"
            >
              ₦ 0.00
            </p>
          </div>
          <div style="margin-bottom: 30px" class="ui divider"></div>
          <div
            style="margin-bottom: 30px"
            *ngIf="lotViewDetails?.requiredTenderDocuments?.length"
          >
            <div class="title-container">
              <div style="display: flex; align-items: center; gap: 10px">
                <div class="header-20">TENDER DOCUMENTS</div>
                <div
                  class="new-label"
                  [ngClass]="{
                    red: lotViewDetails?.requiresPayment,
                    blue: !lotViewDetails?.requiresPayment
                  }"
                >
                  {{ !lotViewDetails?.requiresPayment ? "FREE" : "UNPAID" }}
                </div>
              </div>
              <button
                *ngIf="lotViewDetails?.requiresPayment"
                class="ui primary button"
                style="font-size: 12px; font-weight: 400"
                (click)="printSlip(lotViewDetails)"
              >
                Pay to download documents
              </button>
            </div>
            <div
              class="document-container"
              *ngFor="let document of lotViewDetails?.requiredTenderDocuments"
            >
              <div style="display: flex; align-items: center; gap: 8px">
                <img src="assets/icons/document-icon.svg" alt="" />
                <span class="document-name">{{
                  document?.procDocName || document?.document?.documentName
                }}</span>
              </div>
              <img
                *ngIf="!lotViewDetails?.requiresPayment"
                style="cursor: pointer"
                src="assets/icons/download-light.svg"
                alt=""
                suiPopup
                popupText="Download"
                popupPlacement="bottom"
                [popupInverted]="true"
                (click)="downloadDocument(document)"
              />
            </div>
          </div>
          <!-- <div *ngIf="lotViewDetails?.iframeUrl">
            <div class="title-container">
              <div class="header-20">TENDER INSTRUCTIONS</div>
            </div>
            <iframe
              [src]="lotViewDetails?.iframeUrl"
              width="100%"
              height="600"
              allow="autoplay"
              style="border: none"
            ></iframe>
          </div> -->
          <div *ngIf="lotViewDetails">
            <div class="title-container">
              <div class="header-20">TENDER INSTRUCTIONS</div>
            </div>
            <ng-container
              *ngIf="isPreviewAvailable(lotViewDetails); else noPreview"
            >
              <!-- Check if the document is a pdf -->
              <ng-container
                *ngIf="
                  (lotViewDetails.extension || '').toLowerCase() === 'pdf';
                  else imagePreview
                "
              >
                <iframe
                  [src]="lotViewDetails.iframeUrl"
                  width="100%"
                  height="600"
                  allow="autoplay"
                  style="border: none"
                >
                </iframe>
              </ng-container>
              <!-- Else, if it's an image -->
              <ng-template #imagePreview>
                <img
                  [src]="lotViewDetails.iframeUrl"
                  alt="Document Preview"
                  style="max-width: 100%"
                />
              </ng-template>
            </ng-container>
            <!-- When preview is not available -->
            <ng-template #noPreview>
              <div *ngIf="lotViewDetails.instructionsDocument; else noInstructionsDoc" style="display: flex; flex-direction: column; padding: 30px; align-items: center;">
                <p
                  style="
                    font-size: 20px;
                    text-align: center;
                    color: #505050;
                  "
                >
                  Preview not available
                </p>
                <button
                  (click)="downloadDocument({document: lotViewDetails.instructionsDocument[0]})"
                  class="ui primary button"
                  style="font-size: 12px"
                >
                  Download Instructions
                </button>
              </div>
              <ng-template #noInstructionsDoc>
                <app-no-record-found></app-no-record-found>
              </ng-template>
            </ng-template>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
